import mixpanel from 'mixpanel-browser';

type SendMethod = 'enter_key' | 'send_button';

export function mixPanelDMMessageSent(method: SendMethod) {
    // prevent mixpanel from sending events in test environment
    if (process.env.NODE_ENV === 'test') {
        return;
    }
    mixpanel?.track('dm_message_sent', {
        method
    });
}

export function mixPanelDMImageViewed() {
    // prevent mixpanel from sending events in test environment
    if (process.env.NODE_ENV === 'test') {
        return;
    }
    mixpanel?.track('dm_image_viewed');
}
